import { AppearancePendingChanges } from './appearance-pending-changes.service';
import { Settings } from '../../../core/config/settings.service';
import { Select, Navigate, SetConfig, Deselect } from '../../../shared/appearance/commands/appearance-commands';
import * as i0 from "@angular/core";
import * as i1 from "./appearance-pending-changes.service";
import * as i2 from "../../../core/config/settings.service";
var AppearanceEditor = /** @class */ (function () {
    function AppearanceEditor(changes, settings) {
        this.changes = changes;
        this.settings = settings;
        this.config = {};
        this.loading = false;
    }
    AppearanceEditor.prototype.init = function (iframe, defaultSettings) {
        this.defaultSettings = defaultSettings;
        this.initConfig();
        this.hydrateSeoSection();
        var colors = this.defaultSettings.find(function (setting) { return setting.name === 'colors'; });
        this.config.sections.colors.fields = colors.value.map(function (color) {
            return { name: color.display_name, type: 'color', key: color.name, value: color.value };
        });
        this.initIframe(iframe);
        this.setFieldValues();
    };
    AppearanceEditor.prototype.saveChanges = function () {
        this.changes.save();
    };
    AppearanceEditor.prototype.closeActivePanel = function () {
        this.activePanel = null;
        this.navigate();
    };
    AppearanceEditor.prototype.navigate = function (route) {
        if (!route)
            route = this.config.defaultRoute;
        this.postMessage(new Navigate(route));
    };
    AppearanceEditor.prototype.setConfig = function (key, value) {
        this.postMessage(new SetConfig(key, value));
    };
    AppearanceEditor.prototype.selectNode = function (selector, index) {
        if (index === void 0) { index = 0; }
        if (!selector)
            return;
        this.postMessage(new Select(selector, index));
    };
    AppearanceEditor.prototype.deselectNode = function () {
        this.postMessage(new Deselect());
    };
    AppearanceEditor.prototype.initIframe = function (iframe) {
        iframe.src = this.settings.getBaseUrl() + this.config.defaultRoute + '?preview=' + this.settings.csrfToken;
        this.previewWindow = iframe.contentWindow;
    };
    AppearanceEditor.prototype.postMessage = function (command) {
        this.previewWindow.postMessage(command, '*');
    };
    AppearanceEditor.prototype.setFieldValues = function () {
        var _this = this;
        Object.keys(this.config.sections).forEach(function (key) {
            var configItem = _this.config.sections[key];
            if (configItem.name.toLowerCase() === 'colors')
                return;
            configItem.fields.forEach(function (field) {
                if (typeof field.value === 'undefined') {
                    field.value = _this.getCurrentSetting(field.key);
                }
                if (typeof field.defaultValue === 'undefined') {
                    field.defaultValue = _this.getDefaultSetting(field.key);
                }
            });
        });
    };
    AppearanceEditor.prototype.getCurrentSetting = function (key) {
        if (key.startsWith('env.')) {
            return this.getDefaultSetting('env')[key];
        }
        else {
            return this.settings.get(key);
        }
    };
    /**
     * Get default setting by specified key.
     */
    AppearanceEditor.prototype.getDefaultSetting = function (key) {
        var setting = this.defaultSettings.find(function (s) { return s.name === key; });
        return setting ? setting.value : null;
    };
    AppearanceEditor.prototype.hydrateSeoSection = function () {
        var _this = this;
        var existing = this.config.sections.seo.fields.map(function (item) { return item.key; });
        var seoFields = this.defaultSettings.find(function (setting) { return setting.name === 'seo_fields'; });
        if (!seoFields)
            return;
        seoFields.value.forEach(function (field) {
            if (existing.indexOf(field.name) > -1)
                return;
            _this.config.sections.seo.fields.push(field);
        });
    };
    AppearanceEditor.prototype.initConfig = function () {
        this.config = this.settings.get('vebto.admin.appearance');
        if (!this.config.defaultRoute)
            this.config.defaultRoute = '/';
    };
    AppearanceEditor.ngInjectableDef = i0.defineInjectable({ factory: function AppearanceEditor_Factory() { return new AppearanceEditor(i0.inject(i1.AppearancePendingChanges), i0.inject(i2.Settings)); }, token: AppearanceEditor, providedIn: "root" });
    return AppearanceEditor;
}());
export { AppearanceEditor };
